import { render, staticRenderFns } from "./contentSX.vue?vue&type=template&id=5534cb8a&scoped=true"
import script from "./contentSX.vue?vue&type=script&lang=js"
export * from "./contentSX.vue?vue&type=script&lang=js"
import style0 from "./contentSX.vue?vue&type=style&index=0&id=5534cb8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534cb8a",
  null
  
)

export default component.exports